let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1L8Re"), load("drB6v"), load("cmxKv"), load("7kiNM"), load("5MjBi"), load("97s9d"), load("jjWia")]).then(() => parcelRequire('c8BWz'));